import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthTokenDetails } from './shared/models/authTokenDetails';
import { DTFService } from './dtf.service';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class ConfigurationService {

    constructor(
        private http: HttpClient,
        private dtfService: DTFService) { }
loadConfigurationData(): Promise<void> {
  if (sessionStorage.getItem("Authorization") == null) {
    let username = sessionStorage.getItem('username');
    if (username !== null && username !== undefined) {
      this.dtfService.convertText(username.toLowerCase());
    }
    return this.http
      .post<AuthTokenDetails>(
        this.dtfService.getAuthUrl(),
        { username, password: this.dtfService.conversionEncryptOutput },
        { headers: this.dtfService.getHttpHeaders() }
      )
      .pipe(
        tap(result => {
          sessionStorage.setItem("Authorization", result.token);
          sessionStorage.setItem("userId", result.userId);
        })
      )
      .toPromise()
      .then(() => {}); // ✅ convert to Promise<void>
  }

  return Promise.resolve(); // ✅ also return void here
}

}
